import React, { useState, useEffect } from "react";
import {
  Box,
  Divider,
  Slider,
  Typography,
  Button,
  TextField,
  IconButton,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Tabs,
  Tab,
} from "@mui/material";
import { useMeeting, usePubSub } from "@videosdk.live/react-sdk";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  createBanner,
  createMeetingBanner,
  deleteBanner,
  listBanners,
  updateMeetingBanner,
} from "../Services/BannersApi";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setBannerFont, setBanner, setBannerColor,setBannerTheme } from "../redux/bannerSlice";
import { bannerTheme } from "../utils/constant";
import Accordion from "../Components/Accordion";

const BannerPanel = ({ meeting }) => {
  const { publish } = usePubSub("UPDATE_BANNER");
  const dispatch = useDispatch();
  const mMeeting = useMeeting();
  const savedBgColor = localStorage.getItem("bgColor") || "#00002910";
  const savedBannerText =
    localStorage.getItem("bannerText") || "This is a sample banner.";
  const savedFontSize = Number(localStorage.getItem("fontSize")) || 16;

  const [bgColor, setBgColor] = useState(savedBgColor);
  const [bannerText, setBannerText] = useState(savedBannerText);
  const [fontSize, setFontSize] = useState(savedFontSize);
  const [bannerData, setBannerData] = useState([]); // Start with an empty list
  const [newBanner, setNewBanner] = useState("");
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [isCreatingBanner, setIsCreatingBanner] = useState(false);
  const [hoveredBanner, setHoveredBanner] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const meetingId = queryParams.get("meetingId");
  const banner = useSelector((state) => state?.banner);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedFont, setSelectedFont] = useState("Nexa Extra Light");
  const [activeIndex, setActiveIndex] = useState(banner?.bannerTheme);
  const [errorMessage, setErrorMessage] = useState("");
  const fonts = [
    "Nexa Extra Light",
    "Arial",
    "Times New Roman",
    "Courier New",
    "Verdana",
    "Georgia",
  ];

  // Load banners when component mounts
  useEffect(() => {
    fetchBanners();
  }, []);
  // Save state to localStorage
  useEffect(() => {
    localStorage.setItem("bgColor", bgColor);
    localStorage.setItem("bannerText", bannerText);
    localStorage.setItem("fontSize", fontSize);
  }, [bgColor, bannerText, fontSize]);

  const handleBannerClick = async (banner) => {
    dispatch(setBanner(banner));
    if (mMeeting?.isRecording) {
      const createBannerData = {
        BannerID: banner?.BannerID,
        MeetingID: meetingId,
        BackgroundColor: bgColor,
        FontSize: `${fontSize}px`,
        StartTime: getCurrentTimestamp(),
      };
      await createMeetingBanner(createBannerData);
    }
   sessionStorage.setItem('bannerName', JSON.stringify(banner));
   setSelectedBanner(banner);
    setBannerText(banner.BannerText); // Access BannerText to update state
    const bannerPayload = {
      BannerID: banner?.BannerID,
      message: banner.BannerText, // Send only the BannerText to the publish function
      backgroundColor: bgColor,
      fontSize: `${fontSize}px`,
      bannerStyle: banner?.bannerTheme,
      font: selectedFont,
      status:true,
      
    };
    publish(bannerPayload, { persist: true });
  };

  function getCurrentTimestamp() {
    // const now = new Date();
    // const year = now.getFullYear();
    // const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    // const day = String(now.getDate()).padStart(2, '0');
    // const hours = String(now.getHours()).padStart(2, '0');
    // const minutes = String(now.getMinutes()).padStart(2, '0');
    // const seconds = String(now.getSeconds()).padStart(2, '0');

    // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    //sending UTC time instaed of IST
    return new Date().toISOString();
  }

  const fetchBanners = async () => {
    try {
      const response = await listBanners(localStorage.getItem("user_id"));
      if (response) {
        setBannerData(response.data.Data);
      } else {
        setBannerData([]); // Fallback to empty array if data is not valid
      }
    } catch (error) {
      console.error("Error fetching banners:", error);
      setBannerData([]); // Fallback to empty array on error
    }
  };

  // const handleColorChange = async (id, selectedColor) => {
  const handleColorChange = async (event) => {
    const selectedColor = event.target.value;
    dispatch(setBannerColor(selectedColor));
    setBgColor(selectedColor);
    // setSelectedId(selectedId === id ? null : id);
    if (mMeeting?.isRecording) {
      const createBannerData = {
        BannerID: selectedBanner?.BannerID,
        MeetingID: meetingId,
        BackgroundColor: selectedColor,
        FontSize: `${fontSize}px`,
        StartTime: getCurrentTimestamp(),
        font: selectedFont,
      };
      await createMeetingBanner(createBannerData);
    }
    if (banner) {
      const selectedBanner = banner?.banner;
      if (selectedBanner) {
        const bannerPayload = {
          BannerID: selectedBanner?.BannerID,
          message: selectedBanner.BannerText, // Only pass BannerText
          backgroundColor: selectedColor,
          fontSize: `${fontSize}px`,
          bannerStyle: banner?.bannerTheme,
          font: selectedFont,
        };
        console.log("CallingBannerAPICC");
        publish(bannerPayload, { persist: true });
      }
    }
  };

  const handleFontSizeChange = async (event, newValue) => {
    setFontSize(newValue);
    dispatch(setBannerFont(newValue));
    if (mMeeting?.isRecording) {
      console.log("CallingBannerAPIFF");
      const createBannerData = {
        BannerID: selectedBanner?.BannerID,
        MeetingID: meetingId,
        BackgroundColor: bgColor,
        FontSize: `${newValue}px`,
        StartTime: getCurrentTimestamp(),
        font: selectedFont,
      };
      console.log("createBannerData", createBannerData);
      await createMeetingBanner(createBannerData);
    }
    if (banner) {
      const selectedBanner = banner?.banner;
      if (selectedBanner) {
        const bannerPayload = {
          BannerID: selectedBanner?.BannerID,
          message: selectedBanner.BannerText, // Only pass BannerText
          backgroundColor: bgColor,
          fontSize: `${newValue}px`,
          bannerStyle: banner?.bannerTheme,
          font: selectedFont,
        };
        console.log("CallingBannerAPIFF");
        publish(bannerPayload, { persist: true });
      }
    }
  };

  const handleAddNewBanner = async () => {
    if (newBanner.trim().length <= 1) {
      setErrorMessage("Please enter at least 2 characters for the banner text");
      return;
    }

    setErrorMessage("");
    if (newBanner.trim()) {
      const bannerDataToAdd = {
        UserID: localStorage.getItem("user_id"), // Use actual UserID
        BannerText: newBanner.trim(),
        BackgroundColor: bgColor,
        bannerStyle: banner?.bannerTheme,
      };

      const response = await createBanner(bannerDataToAdd); // API call to create banner
      if (response && response.data) {
        // Ensure bannerData is an array before updating it
        fetchBanners();
        setNewBanner("");
        setIsCreatingBanner(false);
      }
    }
  };

  const handleDeleteBanner = async (banner) => {
    // First, delete the banner via the API call
    const response = await deleteBanner(banner?.BannerID); // API call to delete banner
    if (mMeeting?.isRecording) {
      const updateBannerData = {
        BannerID: banner?.BannerID,
        MeetingID: meetingId,
        EndTime: getCurrentTimestamp(),
      };
      await updateMeetingBanner(updateBannerData);
    }
    if (response && response.data) {
      // Remove the banner from the local state
      setBannerData(bannerData.filter((item) => item !== banner));

      // If the deleted banner is the selected banner, clear the selection and notify PubSub
      if (selectedBanner === banner) {
        setSelectedBanner(null);
        

        // Notify PubSub that there is no banner being shown (empty banner payload)
        const bannerPayload = {
          BannerID: null,
          message: "",
          backgroundColor: bgColor,
          fontSize: `${fontSize}px`,
        };
        publish(bannerPayload, { persist: true });
      }
    }
  };

  const handleStopBanner = async () => {
    sessionStorage.setItem('bannerName', 'null')
    setSelectedBanner(null);
    if (mMeeting?.isRecording) {
      const updateBannerData = {
        BannerID: selectedBanner?.BannerID,
        MeetingID: meetingId,
        EndTime: getCurrentTimestamp(),
      };
      await updateMeetingBanner(updateBannerData);
    }
    const bannerPayload = {
      BannerID: null,
      message: "",
      backgroundColor: bgColor,
      fontSize: `${fontSize}px`,
      status: false,
    };
    publish(bannerPayload, { persist: true });
  };

  const toggleBannerVisibility = (banner) => {
    const isCurrentlySelected = selectedBanner === banner;
    if (isCurrentlySelected) {
      handleStopBanner();
    } else {
      handleBannerClick(banner);
    }
  };

  const handleSelectTheme = async (index) => {
    setActiveIndex(index === activeIndex ? null : index);
    dispatch(setBannerTheme(index));
    if (banner) {
      const selectedBanner = banner?.banner;
      if (selectedBanner) {
        const bannerPayload = {
          BannerID: selectedBanner?.BannerID,
          message: selectedBanner?.BannerText,
          backgroundColor: bgColor,
          fontSize: `${fontSize}px`,
          bannerStyle: index,
          font: selectedFont,
        };

        publish(bannerPayload, { persist: true });
      }
    }
  };

  const handleFontTheme = (event) => {
    setSelectedFont(event.target.value);

    if (selectedBanner) {
      const bannerPayload = {
        BannerID: selectedBanner?.BannerID,
        message: selectedBanner?.BannerText
          ? selectedBanner?.BannerText
          : localStorage.getItem("bannerText"), // Only pass BannerText
        backgroundColor: bgColor,
        fontSize: `${fontSize}px`,
        bannerStyle: banner?.bannerTheme,
        font: event.target.value,
      };
      publish(bannerPayload, { persist: true });
    }
  };

  return (
    <Box
      color="white"
    >
      <Accordion title="Banners">
        <Box style={{ display: "flex", flexDirection: "column" }}>
          <Tabs 
            value={activeTab} 
            onChange={(e, newValue) => setActiveTab(newValue)}
            sx={{
              borderBottom: "0.1vh solid rgba(255, 255, 255, 0.2)",
              "& .MuiTab-root": {
                color: "rgba(255, 255, 255, 0.7)",
                textTransform: "none",
                fontSize: "1.4vh",
                minHeight: "4vh",
                "&.Mui-selected": {
                  color: "white",
                  backgroundColor: "rgba(41, 104, 254, 0.2)",
                }
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "rgba(41, 104, 254, 0.8)",
                height: "0.3vh"
              }
            }}
          >
            <Tab label="Your Banners" />
            <Tab label="Banner Design" />
          </Tabs>

          <Box sx={{ overflowY: "auto", maxHeight: "50vh", paddingTop: "1vh" }}>
            {activeTab === 0 && (
              <div>
                <div>
                  {bannerData?.map((banner, index) => (
                    <div
                      key={index}
                      className="bannerData pointer"
                      onMouseEnter={() => setHoveredBanner(banner)}
                      onMouseLeave={() => setHoveredBanner(null)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor:
                          selectedBanner === banner ? "#ffffff50" : "#ffffff10",
                        position: "relative",
                      }}
                    >
                      <div
                        onClick={() => handleBannerClick(banner)}
                        style={{
                          color: "white",
                          borderRadius: "0.5vh",
                          cursor: "pointer",
                          fontSize: "1.4vh",
                          padding: "1vh 1.2vw",
                          flex: 1,
                          position: "relative",
                        }}
                      >
                        {banner.BannerText}
                        {hoveredBanner === banner && (
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "rgba(0, 0, 0, 0.6)",
                              color: "white",
                              padding: "0.8vh 1.2vw",
                              borderRadius: "0.5vh",
                              cursor: "pointer",
                              fontSize: "1.4vh",
                              gap: "0.8vw",
                              zIndex: 10,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleBannerVisibility(banner);
                            }}
                          >
                            {JSON.parse(sessionStorage.getItem('bannerName'))?.BannerText == banner?.BannerText ? (
                              <>
                                <VisibilityOffIcon style={{ fontSize: "1.6vh" }} />
                                Hide
                              </>
                            ) : (
                              <>
                                <VisibilityIcon style={{ fontSize: "1.6vh" }} />
                                Show
                              </>
                            )}
                          </div>
                        )}
                      </div>
                      <IconButton
                        onClick={() => handleDeleteBanner(banner)}
                        style={{
                          color: "red",
                          fontSize: "1.6vh",
                          width: "3.2vh",
                          height: "3.2vh",
                          flexShrink: 0,
                          marginLeft: "0.5vh",
                        }}
                      >
                        <DeleteIcon style={{ fontSize: "1.6vh" }} />
                      </IconButton>
                    </div>
                  ))}
                </div>
                <div style={{ marginTop: "1vh", marginBottom: "1vh" }}>
                  {!isCreatingBanner ? (
                    <Typography
                      variant="h6"
                      onClick={() => setIsCreatingBanner(true)}
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        textAlignLast: "center",
                        padding: "2%",
                        borderRadius: "1vh",
                        fontSize: "1.6vh",
                      }}
                      className="schedule-btn"
                    >
                      Add New Banner
                    </Typography>
                  ) : (
                    <div>
                      <TextField
                        label="New Banner"
                        variant="filled"
                        fullWidth
                        value={newBanner}
                        onChange={(e) => {
                          setNewBanner(e.target.value);
                          if (e.target.value.trim().length > 1) {
                            setErrorMessage("");
                          } else {
                            setErrorMessage("Please enter at least 2 characters for the banner text");
                          }
                        }}
                        inputProps={{ maxLength: 100 }}
                        helperText={errorMessage || `${newBanner.length}/100 characters`}
                        error={!!errorMessage}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddNewBanner}
                        style={{ marginTop: "1vh", textTransform: "none" }}
                      >
                        Add Banner
                      </Button>
                      <Button
                        variant="outlined"
                        className="cancel-btn"
                        onClick={() => { setIsCreatingBanner(false); setNewBanner(""); }}
                        style={{
                          marginTop: "1vh",
                          textTransform: "none",
                          marginLeft: "1vh",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === 1 && (
              <div style={{ paddingRight: "1vh" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "6.4vh",
                    padding: "1.2vh 0px",
                    alignSelf: "stretch",
                  }}
                >
                  <label
                    htmlFor="colorPicker"
                    style={{ verticalAlign: "top", fontSize: "1.4vh" }}
                  >
                    Brand Color:{" "}
                  </label>
                  <input
                    id="colorPicker"
                    type="color"
                    value={bgColor}
                    onChange={(e) => handleColorChange(e)}
                    style={{
                      padding: "0",
                      border: "none",
                      height: "3vh",
                      width: "3vh",
                    }}
                  />
                </div>

                <Typography gutterBottom style={{ fontSize: "1.4vh" }}>
                  Font Theme
                </Typography>
                <div style={{ marginTop: "3%" }}>
                  <FormControl fullWidth>
                    <Select
                      labelId="font-select-label"
                      value={selectedFont}
                      onChange={handleFontTheme}
                      style={{
                        fontFamily: selectedFont || "Arial",
                        fontSize: "1.6vh",
                        border: "1px solid white",
                      }}
                    >
                      <MenuItem value="" disabled style={{ fontSize: "1.4vh" }}>
                        Select a Font
                      </MenuItem>
                      {fonts.map((font, index) => (
                        <MenuItem key={font} value={font} style={{ fontFamily: font, fontSize: "1.4vh" }}>
                          {font}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "6.4vh",
                    padding: "1.2vh 0px",
                    alignSelf: "stretch",
                  }}
                >
                  <div style={{ fontSize: '1.4vh', letterSpacing: '0.05vh' }}>Font Size</div>
                  <div style={{ fontSize: '1.4vh', letterSpacing: '0.05vh' }}>{fontSize}</div>
                </div>
                <Slider
                  value={fontSize}
                  onChange={handleFontSizeChange}
                  aria-labelledby="font-size-slider"
                  valueLabelDisplay="auto"
                  valueLabelFormat={(value) => `${value}`}
                  min={15}
                  max={40}
                  step={1}
                />
                <div style={{ marginTop: "1vh", fontSize: "1.4vh" }}>
                  <span>Banner Theme</span>
                  <div className="banner-theme">
                    {bannerTheme?.map((item, index) => (
                      <div
                        className={`banner-theme-item ${activeIndex === index ? "active" : ""
                          }`}
                        key={index}
                        onClick={() => handleSelectTheme(index)}
                      >
                        <div
                          style={{
                            ...item,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minWidth: "8vh",
                            wordBreak: "break-word",
                          }}
                        >
                          <span>{item.label}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </Box>
        </Box>
      </Accordion>
    </Box>
  );
};

export default BannerPanel;
